export function findById(value) {
  // console.log('findById ', value.id, this);
  return value.id === Number(this);
}
export function findByUID(value) {
  // console.log('findById ', value.id, this);
  return value.id === this;
}



// WEBPACK FOOTER //
// src/core/utils.js